import httpRequest from "@/servers/http";
import common from "@/common/js/common";

const err_service = "网络请求异常";
const err_login = "登陆异常";
// const qiniuUploader = require("../3rd/qiniuUploader");
// let COS = require("../3rd/cos-wx-sdk-v5.js");
const COS = require("cos-js-sdk-v5");

export default class cosService {
  //mediaType key类型：1图片，2视频
  //typeValue 类型值：type=1 typeValue为teamNo，type=2 typeValue为用户id
  //type 业务类型：1.团队，2个人
  static async uploadFileArr(pathArr, mediaType, typeValue, type) {
    return new Promise(async (resolve, reject) => {
      let newFileList = [];
      let totalFiles = pathArr;
      let uploadedCount = 0;
      let maxUploadNum = 9;
      let readyFileList = [];
      let forCount =
        totalFiles.length < maxUploadNum
          ? 1
          : parseInt(totalFiles.length / maxUploadNum) + 1;
      for (let i = 0; i < forCount; i++) {
        if (uploadedCount + maxUploadNum < totalFiles.length) {
          readyFileList = totalFiles.slice(
            uploadedCount,
            uploadedCount + maxUploadNum,
          );
          uploadedCount += maxUploadNum;
        } else {
          readyFileList = totalFiles.slice(uploadedCount, totalFiles.length);
          uploadedCount = totalFiles.length;
        }
        console.log("uploadFileArr uploadedCount:", uploadedCount);
        if (newFileList.length < pathArr.length) {
          let uploadedFilePart = await this.uploadFileArrDetail(
            readyFileList,
            mediaType,
            typeValue,
            type,
          );
          newFileList.push(...uploadedFilePart);
        }

        if (newFileList.length == totalFiles.length) {
          console.log("uploadFileArr newFileList:", newFileList);
          resolve(newFileList);
        }
      }
    });
  }

  //mediaType key类型：1图片，2视频
  //typeValue 类型值：type=1 typeValue为teamNo，type=2 typeValue为用户id
  //type 业务类型：1.团队，2个人
  static async uploadFileArrDetail(pathArr, mediaType, typeValue) {
    return new Promise(async (resolve, reject) => {
      let that = this;
      // let params = {
      //   num: pathArr.length,
      //   mediaType: mediaType,
      //   typeValue: typeValue,
      //   type: type,
      // };
      let params = {
        suffixArray: JSON.stringify(
          pathArr.map((item) => item.file.name.split(".")[1]),
        ),
        type: mediaType,
        teamNo: typeValue,
      };
      console.log("uploadFileArrDetail params:", params);
      // encryptData:encrypt(params,store.state.userInfo.encryptKey)
      let resp = await httpRequest.getCosUploadInfo(params);
      if (resp.code === 200) {
        let resultStr = common.decrypt(
          resp.data,
          localStorage.getItem("edujia:group:web:key"),
        );
        let result = JSON.parse(resultStr).object;
        console.log("getCosUploadInfo result==", result);
        let urlArr = [];
        for (let idx = 0; idx < pathArr.length; idx++) {
          const path = pathArr[idx];
          const tmpKey = result.uploadKey[idx];
          const uploadedUrl = await this.uploadNew(path, tmpKey, result);
          const info = {
            url: uploadedUrl,
            key: tmpKey,
            seq: path.seq,
          };
          if (path.videoData) {
            info.videoData = path.videoData;
          }
          urlArr.push(info);
        }
        console.log("urlArr:", urlArr);
        resolve(urlArr);
      } else {
        resolve();
      }
    });
  }

  /**
   * 上传方法
   * filePath: 文件本地路径
   * key 文件上传的key
   * result: 服务器返回数据
   */
  static async uploadNew(filePath, key, result) {
    let tmpCredential = JSON.parse(result.uploadToken[key]);
    console.log("filePath...", filePath);
    console.log("result...", result);
    let _this = this;
    return new Promise((resolve, reject) => {
      // var cos = new COS({
      //   getAuthorization: function (options, callback) {
      //     callback({
      //       TmpSecretId: tmpCredential.credentials.tmpSecretId,
      //       TmpSecretKey: tmpCredential.credentials.tmpSecretKey,
      //       // v1.2.0之前版本的sdk使用XCosSecurityToken而不是SecurityToken
      //       SecurityToken: tmpCredential.credentials.sessionToken,
      //       // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
      //       StartTime: tmpCredential.startTime, // 时间戳，单位秒，如：1580000000
      //       ExpiredTime: tmpCredential.expiredTime, // 时间戳，单位秒，如：1580000900
      //     });
      //   },
      // });
      // 直接在组件内初始化 COS 实例
      const cos = new COS({
        SecretId: tmpCredential.credentials.tmpSecretId, // 替换实际 SecretId
        SecretKey: tmpCredential.credentials.tmpSecretKey, // 替换实际 SecretKey
        SecurityToken: tmpCredential.credentials.sessionToken, // 替换实际 SecurityToken
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: tmpCredential.startTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: tmpCredential.expiredTime, // 时间戳，单位秒，如：1580000900
      });

      cos.putObject(
        {
          Bucket: result.bucket,
          Region: result.region,
          Key: key,
          Body: filePath.file,
          onProgress: function (info) {
            console.log("postObject info==", JSON.stringify(info));
          },
        },
        function (err, data) {
          console.log("url==" + result.domain + key);

          if (err) {
            console.error("COS putObject error:", err);
            reject(err);
            return;
          }
          if (data && data.statusCode == 200) {
            resolve(result.domain + key);
          } else {
            reject(
              new Error(
                "COS upload failed: status=" +
                  (data ? data.statusCode : "unknown"),
              ),
            );
          }
        },
      );
    });
  }
}
